import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col, Form, Space, Input, Spin, Select } from "antd";
import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import PropTypes from "prop-types";
import { getRequest } from "../../axios";

const InquiryValue = ({ state, setState, CompanyId, data }) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const [apiLoading, setApiLoading] = useState(false);
  const [materialType, setMaterialType] = useState([]);
  const [selectedMaterialTypes, setSelectedMaterialTypes] = useState({});

  useEffect(() => {
    getMaterialTypeByCategory();
  }, []);

  const getMaterialTypeByCategory = async () => {
    try {
      const materialTypeResponse = await getRequest(
        // `company-material-code/?company_id=${CompanyId}&category_tree=${1}`
          `company-material-code/?category_tree=${1}`
      );
      console.log('materialTypeResponse 001 ', materialTypeResponse);
      setMaterialType(materialTypeResponse.data.results.data);
    } catch (error) {
      console.error("Error fetching material types:", error);
    }
  };

  useEffect(() => {
    const initializeSelectedMaterials = () => {
      const selectedMaterials = {};
      state.vendor_inquiry_value.forEach((item, index) => {
        console.log("item 10", item);
        selectedMaterials[index] = item.company_material_type;
      });
      setSelectedMaterialTypes(selectedMaterials);
    };

    if (state.vendor_inquiry_value) {
      initializeSelectedMaterials();
    }
  }, [state.vendor_inquiry_value]);

  const handleCloneInquiryInputChange = (field, e, index) => {
    let newPersonArr = state.vendor_inquiry_value;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, vendor_inquiry_value: newPersonArr });
  };

  const handleMaterialChangeForInquiry = (index, value) => {
    const selectedMaterial = materialType.find((item) => item.id === value);

    if (selectedMaterial) {
      const updatedInquiryValue = [...state.vendor_inquiry_value];
      updatedInquiryValue[index] = {
        ...updatedInquiryValue[index],
        company_material_type: selectedMaterial.id,
        company_material_type_name: selectedMaterial.material_type_name,
      };

      setState({ ...state, vendor_inquiry_value: updatedInquiryValue });

      setSelectedMaterialTypes((prevSelected) => ({
        ...prevSelected,
        [index]: selectedMaterial.type_name,
      }));
    }
  };
  const setWeightSizeInquiryFieldValue = (data) => {
    console.log('data 5 ', data);
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      console.log('objectValue', objectValue, 'objectKey', objectKey);
      stateArr.push(objectValue);
      // fieldObject["category_tree" + objectKey] = 1;
      fieldObject["company_material_type" + objectKey] =
        objectValue.company_material_type_name;
      fieldObject["minimum_inquiry_value" + objectKey] =
        objectValue.minimum_inquiry_value;
      fieldObject["maximum_inquiry_value" + objectKey] =
        objectValue.maximum_inquiry_value;

      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  useEffect(() => {
    if (CompanyId) {
      const modifiedInquiry = state.vendor_inquiry_value.map(
        (inquiryDetail) => {
          const { id, company, company_name, ...rest } = inquiryDetail;
          return rest;
        }
      );

      setWeightSizeInquiryFieldValue(modifiedInquiry);
    }
  }, [state, CompanyId, t]);
  const addInquiry = () => {
    let newPersonArr = [
      ...state.vendor_inquiry_value,
      {
        company: CompanyId,
        category_tree: 1,
        company_material_type: null,
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
      }]
    setState({
      ...state,
      vendor_inquiry_value: newPersonArr
    });

    console.log('newPersonArr 5', newPersonArr);
    setWeightSizeInquiryFieldValue(newPersonArr);
  };

  const removeInquiry = async (lastIndex) => {
    console.log('lastIndex 2 ', lastIndex);
    let filterPersonArr = state.vendor_inquiry_value.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, vendor_inquiry_value: filterPersonArr });
    // handleDisableOption(lastIndex, null); 
    setWeightSizeInquiryFieldValue(filterPersonArr);
  };

  // const addInquiry = () => {
  //   const newInquiry = [{
  //     company: CompanyId,
  //     category_tree: 1,
  //     company_material_type: null,
  //     company_material_type_name: "",
  //     minimum_inquiry_value: null,
  //     maximum_inquiry_value: null,
  //   }];

  //   setState({
  //     ...state,
  //     vendor_inquiry_value: [...state.vendor_inquiry_value, newInquiry],
  //   });

  //   setWeightSizeInquiryFieldValue(newInquiry)
  // };

  // const removeInquiry = (lastIndex) => {
  //   const updatedInquiries = state.vendor_inquiry_value.filter(
  //     (_, index) => index !== lastIndex
  //   );
  //   setState({ ...state, vendor_inquiry_value: updatedInquiries });

  //   setWeightSizeInquiryFieldValue(updatedInquiries)

  // };

  const filteredMaterialTypes = materialType.filter((material) => {
    return !Object.values(selectedMaterialTypes).includes(material.id);
  });

  return (
    <Spin spinning={apiLoading}>
      <Form onFinish={""} autoComplete="off" ref={formRef}>
        <div className="vendorsubtitle">Inquiry Value</div>
        {state.vendor_inquiry_value &&
          state.vendor_inquiry_value.map((x, index) => {
            console.log("x u", state);
            return (
              <Row key={index} className="customcol" gutter={[16]}>
                <Col xs={24} sm={24} md={12} xl={6} xxl={6}>
                  <Form.Item
                    name={`company_material_type` + index}
                    label={t("Material Type")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("Select material type")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      allowClear
                      placeholder={t("pl_material_type")}
                      onChange={(value) =>
                        handleMaterialChangeForInquiry(index, value)
                      }
                      disabled
                      optionFilterProp="children"
                    >
                      {filteredMaterialTypes.map((item) => {
                        console.log('item 22 ', item)
                        return (
                          <Select.Option key={item.id} value={item.id}>
                            {item.material_type_name}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} xl={6} xxl={6}>
                  <Form.Item
                    name={`minimum_inquiry_value` + index}
                    label={t("label_minimum_inquiry_value")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("min_inquiry_value")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      addonBefore="₹"
                      className="cust-input"
                      placeholder={t("pl_minimum_inquiry_value")}
                      disabled
                      onChange={(value) =>
                        handleCloneInquiryInputChange(
                          "minimum_inquiry_value",
                          value,
                          index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} xl={6} xxl={6}>
                  <Form.Item
                    name={`maximum_inquiry_value` + index}
                    label={t("label_maximum_inquiry_value")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("max_inquiry_value")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      addonBefore="₹"
                      className="cust-input"
                      placeholder={t("pl_maximum_inquiry_value")}
                      disabled
                      onChange={(value) =>
                        handleCloneInquiryInputChange(
                          "maximum_inquiry_value",
                          value,
                          index
                        )
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} xl={6} xxl={6}>
                  <div className="addwrp">
                    <Space>
                      {index !== 0 && (
                        <MinusSquareFilled
                          className="add"
                          onClick={() => removeInquiry(index)}
                        />
                      )}
                      <PlusSquareFilled
                        className="add"
                        onClick={addInquiry}
                      />
                    </Space>
                  </div>
                </Col>
              </Row>
            );
          })}
      </Form>
    </Spin>
  );
};

InquiryValue.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  CompanyId: PropTypes.number,
  data: PropTypes.array,
};

export default InquiryValue;
